export default __webpack_public_path__ + "static/media/007-dog.3cc84532.svg";